import _ from "lodash";
import moment from "moment";
import { ExportRequestConfiguredOntologyList } from "../../../swagger-gen/web-secured/models/export-request-configured-ontology-list";

/**
 * Calculates the elapsed duration from a given date to the current moment in UTC.
 * Returns the formatted duration as `XD HHh MMmin` if the duration exceeds 1 day,
 * otherwise as `HHh MMmin`.
 *
 * @param lastDate - A date in ISO 8601 format from which the duration is calculated.
 * @returns {string} - The formatted elapsed duration or `"Invalid date"` if the input date is invalid.
 */
export function calculateDuration(lastDate: string): string {
  if (!lastDate || !moment(lastDate, moment.ISO_8601, true).isValid()) {
    return "";
  }

  const now = moment.utc();
  const durationDiff = moment.duration(now.diff(moment.utc(lastDate)));
  const days = durationDiff.days();
  const hours = durationDiff.hours().toString().padStart(2, "0");
  const minutes = durationDiff.minutes().toString().padStart(2, "0");

  return days > 0
    ? `${days}j ${hours}h ${minutes}min`
    : `${hours}h ${minutes}min`;
}

export function parseExportRequestConfiguredOntologies(configuredOntologies?: ExportRequestConfiguredOntologyList) {
  return configuredOntologies?.map((item: any) => ({pathUri: extractUidUrlFromRequestConfiguredOntolog(item.pathUri), sheetName: item.sheetName})) || [];
}

/**
 * @deprecated : A supprimer quand le terme "web" sera supprimé dans le back.
 * Supprime la partie "/web/" de l'url
 * @param sheetName
 */
export function extractUidUrlFromRequestConfiguredOntolog(pathUri: string | undefined): string {
  return pathUri?.replace('/web/', '') || '';
}
